import {
	removeError,
	doDateFieldValidation
} from '../lib/forms';

let form;

const init = () => {
	form = document.querySelector('.js-start-quiz-form');
	if (!form) return;

	// только если нужен ввод возраста
	let dateInput = form.querySelector('[name="user-birthday"]');
	if (!dateInput) return;

	if (dateInput.dateMask) {
		dateInput.dateMask.on('accept', function() {
			if (dateInput.dateMask.typedValue !== null) {
				removeError(dateInput);
			}
		});
	}

	let overlayElem = form.querySelector('.form__overlay');
	let dateStateInput = form.querySelector('[name="user-birthday-saved"]');
	let formSubmitInput = form.querySelector('[name="next"]');

	form.addEventListener('submit', (e) => {
		let dateSaved = dateStateInput.value === 'y';
		if (!dateSaved) {
			e.preventDefault();

			let dateChecked = doDateFieldValidation(form, 'user-birthday', e);
			if (!dateChecked) {
				return;
			}

			let formData = new FormData(form);
			formData.set('action', 'save');

			if (overlayElem) {
				overlayElem.style.display = 'block';
			}

			fetch('/include/ajax/form-quiz-start.php', {
				method: 'POST',
				body: formData
			})
				.then((response) => {
					if (!response.ok) {
						throw new Error(`HTTP error! Status: ${response.status}`);
					}
					return response.json();
				})
				.then((result) => {
					if (result.error) {
						throw new Error(result.message);
					}

					dateStateInput.value = 'y';
					form.requestSubmit(formSubmitInput);

				})
				.catch((error) => {
					if (overlayElem) {
						overlayElem.style.display = 'none';
					}
					alert(error.message);
				});
		}
	});
};

export default {
	init
};